import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/location-route-dispatch-request-schema'
const { locationRouteDispatchRequestSchema: schema } = schemaSettings
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'

const service = apiClient.service('location-route-dispatch-requests')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'locationRouteDispatchRequests', storePrefix: name }),
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
